<template>
  <div class="main-container">
      <tl-header type="h1">Summary</tl-header>
      <div>
      <div class="row-container center">
        <div class="company-info" v-show="showIntro">
          <img class="image" src="@/assets/team.svg" />
          <div><img class="closeImage" src="@/assets/close.png" /></div>
          <div class="fontStyle">
            <br><br><span>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
              unknown printer took a galley of type and scrambled it to make a type specimen book.
              It has survived not only five centuries, but also the leap into electronic typesetting,
              remaining essentially unchanged. It was popularised in the 1960s with the release of
              Letraset sheets containing
            </span><br>
            <span>preferrences from advance settings in the same section</span>
            <div class="divider"></div><br><br>
            <btn text="Get Started" type="secondary" @click="showSummary"/>
          </div>
        </div>
      </div>
    </div>
    <div>
      <summary-table></summary-table>
    </div>
  </div>
</template>

<script>
import SummaryTable from './summaryTable.vue';
export default {
  components: {
    SummaryTable
  },
  data() {
    return {
      showIntro: false,
    }
  },
  methods: {
    showSummary() {
      this.showIntro = false;
    },
    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/components/introPage.scss"
</style>
